module.exports = {"130203001":"乔屯街道","130203002":"文化路街道","130203003":"钓鱼台街道","130203004":"东新村街道","130203005":"缸窑街道","130203006":"机场路街道","130203007":"河北路街道","130203008":"龙东街道","130203009":"大里街道","130203010":"光明街道","130203011":"翔云道街道","130203100":"韩城镇","130203101":"果园镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130203.json
// module id = 167
// module chunks = 0